import script from "./TRIAL_EXPIRY_REMINDER.vue?vue&type=script&lang=ts&setup=true"
export * from "./TRIAL_EXPIRY_REMINDER.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__